
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/delayedsend-vs-native-teams-features-comparison",
      function () {
        return require("private-next-pages/article/delayedsend-vs-native-teams-features-comparison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/delayedsend-vs-native-teams-features-comparison"])
      });
    }
  